/* /pair?code=XXXXXX — opened by Brightivity Helper's "Open Brightivity" button. Pairs at once. */
import { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { TopBar } from '../app/AppShell.jsx';
import { pairComputer } from '../api/bridge.js';
import { Button, Card, EmptyState, Spinner } from '../ui/index.jsx';
import { ConnectComputer } from '../features/computers/computers.jsx';
import { useTranslation } from 'react-i18next';

export default function PairPage() {
  const { t } = useTranslation('bv');
  const [params] = useSearchParams();
  const code = (params.get('code') || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 6);
  const [state, setState] = useState(code.length === 6 ? { busy: true } : { manual: true });
  const once = useRef(false);
  useEffect(() => {
    if (code.length !== 6 || once.current) return;
    once.current = true;
    pairComputer(code).then((r) => setState(r.ok ? { done: r.data } : { error: r.error }));
  }, [code]);
  return (
    <div className="bv-content">
      <TopBar title={t('pair.title')} subtitle={t('pair.subtitle')} />
      {state.busy && <Card><div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}><Spinner /></div></Card>}
      {state.done && (
        <Card data-testid="pair-done">
          <EmptyState icon="check" title={t('computers.connect.connected', { name: state.done.name })} action={<Button as={Link} to="/print" variant="coral" icon="print">{t('pair.printSomething')}</Button>}>
            {t('pair.done')}
          </EmptyState>
        </Card>
      )}
      {(state.error || state.manual) && (
        <>
          {state.error && <Card style={{ marginBottom: 20 }}><p className="bv-error-text" role="alert">{state.error}</p></Card>}
          <ConnectComputer initialCode={code} />
        </>
      )}
    </div>
  );
}
